import { crewShortfall } from "../lib/jobs";
import type { Booking } from "../lib/supabase";
import { Chip } from "./States";

/** Booking status, or "Needs N more" when a confirmed/allocated shift is short of crew. */
export function BookingChip({ b }: { b: Booking }) {
  const short = crewShortfall(b);
  if (short !== null) return <Chip tone="accent">Needs {short} more</Chip>;
  return <Chip value={b.status} />;
}
